import { useState, useEffect, useCallback } from "react";

import "../common/Util.css";
import "../common/skeleton-effect.css";
import { ReactComponent as SearchIc } from "../../assets/svg/search.svg";
import { ReactComponent as AddIc } from "../../assets/svg/add_icon.svg";
import { ReactComponent as EmailView } from "../../assets/svg/email_view_ic.svg";
import { ReactComponent as ListView } from "../../assets/svg/list_view_ic.svg";
import { ReactComponent as SelectGrid } from "../../assets/svg/seelct_grid_ic.svg";
import { ReactComponent as SelectList } from "../../assets/svg/select_list_ic.svg";
import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../common/deleteModel";
import DateRangePicker from "../common/dateRange";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { getTripsListApi, deleteTripsApi, updateDriverAPI, getNextMilestoneApi, getUpdateMilestoneApi, getProductDetailsApi, productConfirmationApi, paymentUpdateApi, paymentUpdateImageApi, addTripHistoryAttachmentsApi, downloadTripTemplateApi, downloadBase64File } from "./trips-api";
import { useGlobal } from "../../GlobalContext";
import { sanitizeInput } from "../common/security-utils";
import CommonSnackbar, { CommonPagination } from "../common/reusable-commponent";
import SearchableDropdown from "../common/commonDropDown";

import DriverAllocationModal from "./DriverAllocationModal";
import MilestoneUpdateModal from "./MilestoneUpdateModal";
import DeliveredModal from "./DeliveredModal";
import PaymentModal from "./PaymentModal";
import { ReactComponent as DownloadIc } from "../../assets/svg/download_Ics.svg";
import { ReactComponent as ImportIc } from "../../assets/svg/import_ic.svg";
import StopsExcelUploadModal from "../stops/stops-excel-upload-model";
import TripsListView from "./TripsListView";
import TripsGridView from "./TripsGridView";
import "./trips-list.css";

const ICON_STYLE = { width: "16px", height: "16px" };

const SORT_BY_OPTIONS = [
  { value: "created asc", label: "Created (Oldest)" },
  { value: "created desc", label: "Created (Newest)" },
  { value: "updated asc", label: "Updated Date (Oldest)" },
  { value: "updated desc", label: "Updated Date (Newest)" },
];

const INITIAL_MILESTONE_ERRORS = {
  status: "",
  comments: "",
  signature: "",
  attachments: "",
  latitude: "",
  longitude: "",
};

const INITIAL_ALLOCATION_ERRORS = {
  vehicle_id: "",
  users: "",
};

const INITIAL_PAYMENT_ERRORS = {
  payment_method: "",
  amount: "",
  signature: "",
  attachments: "",
};

export const TripsListing = () => {
  const { rolePermissionList } = useGlobal();
  const navigate = useNavigate();

  // API Config
  const apiUrl = process.env.REACT_APP_API_URL;

  // States
  const [showExcelUploadModal, setShowExcelUploadModal] = useState(false);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [selectedSortby, setSelectedSortBy] = useState(SORT_BY_OPTIONS[1]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [active, setActive] = useState("grid");
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tripsList, setTripsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showDriverAllocationModal, setShowDriverAllocationModal] = useState(false);
  const [allocationTripId, setAllocationTripId] = useState(null);
  const [customerSelect, setCustomerSelect] = useState(null);
  const [locationSelect, setLocationSelect] = useState(null);
  const [statusSelect, setStatusSelect] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startDateSave, setStartDateSave] = useState(null);
  const [endDateSave, setEndDateSave] = useState(null);
  const [snackbar, setSnackbar] = useState({ show: false, message: "", status: null });
  const [showMilestoneModal, setShowMilestoneModal] = useState(false);
  const [milestoneDetails, setMilestoneDetails] = useState({});
  const [showDeliveredModal, setShowDeliveredModal] = useState(false);
  const [stopProduct, setStopProduct] = useState([]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [deliveryContext, setDeliveryContext] = useState({
    stop_id: 0,
    trip_id: 0,
    milestone_id: 0,
  });

  // Error Message States
  const [errorMsgMilestone, setErrorMsgMilestone] = useState(INITIAL_MILESTONE_ERRORS);
  const [errorMsgAllocation, setErrorMsgAllocation] = useState(INITIAL_ALLOCATION_ERRORS);
  const [errorMsgPaymentUpdate, setErrorMsgPaymentUpdate] = useState(INITIAL_PAYMENT_ERRORS);

  // Permission Checker
  const checkPermission = useCallback(
    (permission) => {
      if (!rolePermissionList || !Array.isArray(rolePermissionList)) return false;
      return rolePermissionList.some((element) => element?.["name"] === "Trips" && element?.["menu_permission"] === true && element?.[permission] === true);
    },
    [rolePermissionList]
  );

  const handleSnackbarClose = useCallback(() => setSnackbar((prev) => ({ ...prev, show: false })), []);

  const triggerSnackbar = useCallback((message, status) => {
    setSnackbar({ show: true, message: sanitizeInput(message), status });
  }, []);

  /** Parse validation errors from API response into a state object */
  const parseValidationErrors = useCallback((errors, template) => {
    if (!errors || typeof errors !== "object") return template;
    const result = { ...template };
    Object.entries(errors).forEach(([key, value]) => {
      const rawMsg = Array.isArray(value) && value.length > 0 ? value[0] : "";
      result[key] = sanitizeInput(rawMsg);
    });
    return result;
  }, []);

  // Debounce search effect
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => clearTimeout(handler);
  }, [search]);

  // Open Delete Modal when deleteId is set
  useEffect(() => {
    if (deleteId) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  // Select handlers
  const handleSelectCustomer = useCallback((option) => setCustomerSelect(option), []);
  const handleClearCustomer = useCallback(() => setCustomerSelect(null), []);
  const handleSelectLocation = useCallback((option) => setLocationSelect(option), []);
  const handleClearLocation = useCallback(() => setLocationSelect(null), []);
  const handleSelectStatus = useCallback((option) => setStatusSelect(option), []);
  const handleClearStatus = useCallback(() => setStatusSelect(null), []);

  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);

  const handleDownloadTemplate = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await downloadTripTemplateApi();

      if (res.data.success && res.data.base64) {
        let filename = "trip_template.xlsx";
        if (res.data.url) {
          const urlParts = res.data.url.split("/");
          const filenamePart = urlParts[urlParts.length - 1].split("?")[0];
          if (filenamePart) {
            filename = filenamePart;
          }
        } else if (res.data.filename) {
          filename = res.data.filename;
        }

        downloadBase64File(res.data.base64, filename);
        triggerSnackbar("Template downloaded successfully", true);
      } else {
        triggerSnackbar(res.data.message || "Failed to download template", false);
      }
    } catch (err) {
      triggerSnackbar("Error downloading template", false);
    } finally {
      setIsLoading(false);
    }
  }, [triggerSnackbar]);
  const handleDateChange = useCallback(({ start, end }) => {
    setStartDate(start);
    setEndDate(end);

    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;

    setStartDateSave(formattedStart);
    setEndDateSave(formattedEnd);
  }, []);
  // useEffect

  const getTripsList = useCallback(async () => {
    setIsLoading(true);
    const [field, dir] = selectedSortby?.value?.split(" ") || ["Created", "desc"];
    const param = {
      limit: itemsPerPage,
      skip: itemOffset * itemsPerPage,
      search: debouncedSearch,
      status: statusSelect?.value ?? "",
      customer_id: customerSelect?.value ?? "",
      location_id: locationSelect?.value ?? "",
      from_date: startDateSave,
      to_date: endDateSave,
      sort_field: field,
      sort_dir: dir,
    };
    try {
      const response = await getTripsListApi(param);
      if (response.data.success === true) {
        setTotalCount(response.data.total_rec ?? 0);
        setPageCount(response.data.total_pgs ?? 0);
        setTripsList(response.data.trips ?? []);
      }
    } catch (err) {
      // Error handled by api-service
    } finally {
      setIsLoading(false);
    }
  }, [itemsPerPage, itemOffset, debouncedSearch, selectedSortby, statusSelect, customerSelect, locationSelect, startDateSave, endDateSave]);

  useEffect(() => {
    getTripsList();
  }, [getTripsList]);
  const deleteTrip = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await deleteTripsApi(deleteId);
      if (response?.data?.success === true) {
        getTripsList();
        triggerSnackbar(response.data.message || "Trip deleted successfully", true);
        setDeleteId(null);
        setIsOpenDelete(false);
      } else {
        triggerSnackbar(response?.data?.message || "Failed to delete trip", false);
      }
    } catch (err) {
      triggerSnackbar("An error occurred during deletion", false);
    } finally {
      setIsLoading(false);
    }
  }, [deleteId, getTripsList, triggerSnackbar]);
  const handleDriverAllocate = useCallback(
    async (payload) => {
      try {
        const response = await updateDriverAPI(payload);
        if (response.status === 400) {
          setErrorMsgAllocation(parseValidationErrors(response.data.error, INITIAL_ALLOCATION_ERRORS));
        } else if (response.data.success === true) {
          setShowDriverAllocationModal(false);
          triggerSnackbar(response.data.message || "Driver assigned successfully", true);
          getTripsList();
        } else {
          setErrorMsgAllocation(parseValidationErrors(response?.data?.error, INITIAL_ALLOCATION_ERRORS));
        }
      } catch (err) {
        // silent
      } finally {
        setIsLoading(false);
      }
    },
    [getTripsList, triggerSnackbar, parseValidationErrors]
  );

  const getMilestoneDetails = useCallback(async (id) => {
    try {
      setIsLoading(true);
      const response = await getNextMilestoneApi(id);
      if (response.data.success === true) {
        setMilestoneDetails(response.data);
        setShowMilestoneModal(true);
      }
    } catch (err) {
      // Error handled by apiCall
    } finally {
      setIsLoading(false);
    }
  }, []);
  const handleMilestoneUpdate = useCallback(
    async (payload) => {
      try {
        const response = await getUpdateMilestoneApi(payload);
        if (response?.status === 400) {
          setErrorMsgMilestone(parseValidationErrors(response?.data?.error, INITIAL_MILESTONE_ERRORS));
        } else if (response?.data?.success === true) {
          const tripHistoryId = response?.data?.trip_history_id;
          if (response?.data?.redirectPage === "production-confirmation") {
            const context = {
              stop_id: payload.stop_id,
              trip_id: milestoneDetails?.trip?.id ?? 0,
              milestone_id: milestoneDetails?.status?.[0]?.milestone_id ?? 0,
            };
            setDeliveryContext(context);
          }

          if (payload.attachments && payload.attachments.length > 0 && tripHistoryId) {
            try {
              await addTripHistoryAttachmentsApi(tripHistoryId, { attachments: payload.attachments });
            } catch (attachErr) {
              // Silently handle attachment errors
            }
          }

          setShowMilestoneModal(false);
          if (response?.data?.redirectPage === "") {
            getTripsList();
            setMilestoneDetails({});
          } else if (response?.data?.redirectPage === "production-confirmation") {
            getProductDetails(payload.stop_id);
          }
        } else {
          setErrorMsgMilestone(parseValidationErrors(response?.data?.error, INITIAL_MILESTONE_ERRORS));
        }
        return response;
      } catch (err) {
        triggerSnackbar("Failed to update milestone", false);
      } finally {
        setIsLoading(false);
      }
    },
    [getTripsList, milestoneDetails, triggerSnackbar, parseValidationErrors]
  );

  const getProductDetails = useCallback(async (stopId) => {
    try {
      setIsLoading(true);
      const response = await getProductDetailsApi(stopId);
      if (response.data.success === true) {
        setStopProduct(
          response.data.products?.map((product) => ({
            ...product,
            duplicateprice: product.price,
            singleprice: (parseFloat(product.price) || 0) / (parseInt(product.quantity) || 1),
            returnqty: 0,
            dueqty: 0,
          }))
        );
        setShowDeliveredModal(true);
      }
    } catch (err) {
      // Error handled by apiCall
    } finally {
      setIsLoading(false);
    }
  }, []);

  const handleDeliveryUpdate = useCallback(
    async (payload) => {
      try {
        const updatePayload = {
          ...payload,
          stop_id: deliveryContext.stop_id,
          trip_id: deliveryContext.trip_id,
          milestone_id: deliveryContext.milestone_id,
        };

        if (updatePayload.stop_id === 0 || updatePayload.trip_id === 0 || updatePayload.milestone_id === 0) {
          triggerSnackbar("Error: Missing required information. Please update the milestone first.", false);
          return;
        }

        const response = await productConfirmationApi(updatePayload);

        if (response?.data?.success === true) {
          if (response.data.redirectPage === "") {
            setShowDeliveredModal(false);
            getTripsList();
          } else if (response.data.redirectPage === "payment") {
            setShowDeliveredModal(false);
            setShowPaymentModal(true);
          }
        } else {
          triggerSnackbar(response?.data?.message || "Failed to update delivery information", false);
        }
      } catch (err) {
        triggerSnackbar("An error occurred while updating delivery information", false);
      } finally {
        setIsLoading(false);
      }
    },
    [deliveryContext, getTripsList, triggerSnackbar]
  );

  const handlePaymentUpdate = useCallback(
    async (payload) => {
      try {
        const updatePayload = {
          ...payload,
          stop_id: deliveryContext.stop_id,
          trip_id: deliveryContext.trip_id,
          milestone_id: deliveryContext.milestone_id,
        };

        if (updatePayload.stop_id === 0 || updatePayload.trip_id === 0 || updatePayload.milestone_id === 0) {
          triggerSnackbar("Missing required information for payment. Please update the milestone first.", false);
          return;
        }

        const response = await paymentUpdateApi(updatePayload);

        if (response?.status === 400) {
          setErrorMsgPaymentUpdate(parseValidationErrors(response?.data?.error, INITIAL_PAYMENT_ERRORS));
        } else if (response?.data?.success === true) {
          if (response.data.id && (updatePayload.signature || (updatePayload.attachments && updatePayload.attachments.length > 0))) {
            await paymentUpdateImageApi({
              id: response.data.id,
              billing_proof: (updatePayload.attachments && updatePayload.attachments[0]) || "",
              signature: updatePayload.signature || "",
            });
          }
          setShowPaymentModal(false);
          getTripsList();
          triggerSnackbar(response.data.message || "Payment updated successfully", true);
        } else {
          setErrorMsgPaymentUpdate(parseValidationErrors(response?.data?.error, INITIAL_PAYMENT_ERRORS));
          if (response?.data?.message) {
            triggerSnackbar(response.data.message, false);
          }
        }
      } catch (err) {
        triggerSnackbar("An error occurred while updating payment", false);
      } finally {
        setIsLoading(false);
      }
    },
    [deliveryContext, getTripsList, triggerSnackbar, parseValidationErrors]
  );

  return (
    <>
      <StopsExcelUploadModal
        show={showExcelUploadModal}
        type={"Trip"}
        onHide={() => setShowExcelUploadModal(false)}
        onUploadSuccess={() => {
          setItemOffset(0);
          getTripsList();
          triggerSnackbar("Trip imported successfully", true);
        }}
      />
      <DriverAllocationModal show={showDriverAllocationModal} onHide={() => setShowDriverAllocationModal(false)} tripId={allocationTripId} apiUrl={apiUrl} onSubmit={handleDriverAllocate} errorMsgAllocation={errorMsgAllocation} />
      <MilestoneUpdateModal
        show={showMilestoneModal}
        onHide={() => {
          setShowMilestoneModal(false);
          setMilestoneDetails({});
        }}
        onSubmit={handleMilestoneUpdate}
        milestoneDetails={milestoneDetails}
        errorMsgMilestone={errorMsgMilestone}
      />
      <DeliveredModal
        show={showDeliveredModal}
        onHide={() => {
          setShowDeliveredModal(false);
        }}
        onSubmit={handleDeliveryUpdate}
        products={stopProduct}
      />
      <PaymentModal show={showPaymentModal} onHide={() => setShowPaymentModal(false)} onSubmit={handlePaymentUpdate} errorMsgPaymentUpdate={errorMsgPaymentUpdate} />
      <DeleteModal
        title={"trip"}
        isOpen={isOpenDelete}
        onClose={() => {
          setIsOpenDelete(false); // close modal
          setDeleteId(null); // reset selected ID
        }}
        onDelete={deleteTrip}
      />
      <div>
        <div className="trips-list-wrapper bg-half-white p-2 scroll-hidden">
          <div className="pb-2">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div className="trips-header-title my-heading fs-24 fw-600">
                Trips : {totalCount}
              </div>
              <div className="d-flex flex-wrap gap-3">
                <div className="search-wrapper d-flex align-items-center gap-2 px-3 py-2">
                  <SearchIc />
                  <input type="text" placeholder="Search" className="trips-search-input border-0 outline-0 rounded-3 fs-14 fw-500 textcolor" value={search || ""} onChange={(e) => setSearch(e.target.value)} />
                </div>

                {/* Add New Vendor */}
                {checkPermission("create_permission") && (
                  <div
                    className="add-trip-btn cursor-pointer add-new d-flex align-items-center justify-content-center gap-2 px-3"
                    onClick={() => navigate("/trips/create")}
                  >
                    <div className="add-trip-btn-icon">
                      <AddIc style={{ width: "16px", height: "16px" }} />
                    </div>

                    <div className="fs-12 fw-600" style={{ lineHeight: "16px" }}>
                      New Trip
                    </div>
                  </div>
                )}

                {/* Import */}
                <div className="import-action-wrapper cursor-pointer d-flex align-items-center justify-content-center gap-2 px-3">
                  {checkPermission("create_permission") && (
                    <div
                      className="template-btn cursor-pointer add-new d-flex align-items-center justify-content-center gap-2 px-3"
                      onClick={handleDownloadTemplate}
                    >
                      <DownloadIc />
                      <div className="fs-12 fw-600" style={{ lineHeight: "16px" }}>
                        Template
                      </div>
                    </div>
                  )}

                  {checkPermission("create_permission") && (
                    <div
                      className="import-btn cursor-pointer add-new d-flex align-items-center justify-content-center gap-2 px-3"
                      onClick={() => setShowExcelUploadModal(true)}
                    >
                      <div className="add-trip-btn-icon">
                        <ImportIc />
                      </div>
                      <div className="fs-12 fw-600" style={{ lineHeight: "16px" }}>
                        Import
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Second Row */}
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex flex-wrap justify-content-start gap-2">
                <div onClick={(e) => e.stopPropagation()}>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="light"
                      id="dropdown-sort"
                      className="sort-dropdown-toggle d-flex align-items-center justify-content-between"
                      title={selectedSortby.label}
                    >
                      <span className="fs-12 fw-400 textGrey">Sort by :</span>
                      <span className="d-flex align-items-center px-1">
                        <span className="dropdown-text">{selectedSortby.label}</span>
                      </span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="sort-dropdown-menu">
                      {SORT_BY_OPTIONS.map((option) => (
                        <Dropdown.Item
                          className="fs-14 fw-500 textcolor"
                          key={option.value}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedSortBy(option);
                          }}
                          active={selectedSortby.value === option.value}
                        >
                          {option.label}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div>
                  <SearchableDropdown apiUrl={`${apiUrl}customer/autosuggestion`} placeholder="Customer" value={customerSelect} onSelect={handleSelectCustomer} handleClear={handleClearCustomer} />
                </div>
                <div>
                  <SearchableDropdown apiUrl={`${apiUrl}get_locations`} placeholder="Location" value={locationSelect} onSelect={handleSelectLocation} handleClear={handleClearLocation} />
                </div>
                <div>
                  <SearchableDropdown apiUrl={`${apiUrl}trips/status`} placeholder="Status" value={statusSelect} onSelect={handleSelectStatus} handleClear={handleClearStatus} />
                </div>
                <div
                  className="date-range-filter-wrapper d-flex align-items-center px-1"
                >
                  <span className="fs-12 fw-400 textGrey">Date :</span>
                  <span className="dropdown-text1 ps-1 pb-1">
                    <DateRangePicker onChange={handleDateChange} startDate={startDate} endDate={endDate} style={{ border: "none", padding: "0", backgroundColor: "transparent" }} />
                  </span>
                </div>
                <div
                  className="reset-filters-btn cursor-pointer ms-1 fs-12 fw-400 textGrey text-decoration-underline d-flex align-items-center justify-content-center"
                  onClick={() => {
                    setCustomerSelect(null);
                    setLocationSelect(null);
                    setStatusSelect(null);
                    setStartDateSave(null);
                    setEndDateSave(null);
                    setStartDate(null);
                    setEndDate(null);
                    setSearch("");
                  }}
                >
                  Reset Filters
                </div>
              </div>

              <div
                className="view-toggle-wrapper rounded-3 toggleBg d-flex mt-2"
              >
                <div
                  onClick={() => setActive("list")}
                  className={`view-toggle-item d-flex align-items-center justify-content-center rounded-3  ${active === "list" ? "bg-primary1" : ""}`}
                >
                  {active === "list" ? <ListView style={ICON_STYLE} /> : <SelectList style={ICON_STYLE} />}
                </div>

                <div
                  onClick={() => setActive("grid")}
                  className={`view-toggle-item d-flex align-items-center justify-content-center rounded-3 ${active === "grid" ? "bg-primary1" : ""}`}
                >
                  {active === "grid" ? <SelectGrid style={ICON_STYLE} /> : <EmailView style={ICON_STYLE} />}
                </div>
              </div>
            </div>
          </div>
          {active === "list" && (
            <TripsListView
              isLoading={isLoading}
              tripsList={tripsList}
              hoveredIndex={hoveredIndex}
              setHoveredIndex={setHoveredIndex}
              checkPermission={checkPermission}
              navigate={navigate}
              setDeleteId={setDeleteId}
            />
          )}
          {active === "grid" && (
            <TripsGridView
              isLoading={isLoading}
              tripsList={tripsList}
              checkPermission={checkPermission}
              navigate={navigate}
              setDeleteId={setDeleteId}
              getMilestoneDetails={getMilestoneDetails}
              setAllocationTripId={setAllocationTripId}
              setShowDriverAllocationModal={setShowDriverAllocationModal}
            />
          )}
        </div>
        <CommonPagination
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          pageCount={pageCount + 1}
          onPageChange={handlePageClick}
          forcePage={itemOffset}
        />
      </div>
      <CommonSnackbar show={snackbar.show} onClose={handleSnackbarClose} message={snackbar.message} isSuccess={snackbar.status} />
    </>
  );
};
